import {EnrollCabinet} from '../model/enroll-cabinet';
import {DicsEnrollCabinet} from '../model/dics-enroll-cabinet';
import {Utils} from '../../../../common/services/Utils';
import {AlternativeCollegeItem} from './tabs/enroll-entrans-info/model/alternative-college-item';
import {EnrollApplicationService} from '../../../common-main/services/enroll-application.service';
import {ParticipateInRanging} from '../../../../common/enums/participate-in-ranging.enum';
import {SpecialExamType} from '../../../../common/enums/special-exam-type.enum';
import {ExamsSubjectsBalls} from '../model/edu-info/exams-subjects-balls';

export class EnrollCabinetValidation {

  validateForm(enrollCabinet: EnrollCabinet, validationErrors: any[], dics: DicsEnrollCabinet, isTechSecretary: boolean, isEnroll: boolean, _utils: Utils, _enrollApplicationService: EnrollApplicationService, userCollegeId): boolean {
    // Личные данные

    if (isTechSecretary) {
      if (enrollCabinet.collegeId > 0) {
        if (enrollCabinet.collegeId != userCollegeId) {
          validationErrors.push('priority_college_incorrect_college');
        }
      } else {
        enrollCabinet.userCollegeId = userCollegeId;
      }
    }
    enrollCabinet.edu_info.entrance_exams_info.mandatory_subjects.forEach(ms => {
      if (!(ms.subjectId || (enrollCabinet.edu_info.edu_institute_country != 113 && !isTechSecretary)
        || enrollCabinet.edu_info.finishedCorrectionalSchool
          || (!isTechSecretary && enrollCabinet.edu_info.edu_institute_graduate == 2)
          || enrollCabinet.edu_info.type_of_admission == 2)
        && validationErrors.indexOf('enroll_cabinet_page.edu_info_tab.entrance_exams_info.mandatory_subjects') == -1) {
        validationErrors.push('enroll_cabinet_page.edu_info_tab.entrance_exams_info.mandatory_subjects');
      }
    });
    enrollCabinet.edu_info.entrance_exams_info.profile_subjects.forEach(ps => {
      if (!(ps.subjectId || (enrollCabinet.edu_info.edu_institute_country != 113 && !isTechSecretary)
        || enrollCabinet.edu_info.finishedCorrectionalSchool
          || (!isTechSecretary && enrollCabinet.edu_info.edu_institute_graduate == 2)
          || enrollCabinet.edu_info.type_of_admission == 2)
        && validationErrors.indexOf('enroll_cabinet_page.edu_info_tab.entrance_exams_info.profile_subjects') == -1) {
        validationErrors.push('enroll_cabinet_page.edu_info_tab.entrance_exams_info.profile_subjects');
      }
    });

    if (!enrollCabinet.personal_info.surname ||
      !enrollCabinet.personal_info.firstname ||
      !enrollCabinet.personal_info.birth_date ||
      !enrollCabinet.personal_info.sex ||
      !enrollCabinet.personal_info.nationality ||
      !enrollCabinet.personal_info.martial_status ||
      !enrollCabinet.personal_info.citizenship) {

      /*if (enrollCabinet.personal_info.citizenship !== 113) {
        if (!enrollCabinet.personal_info.country_of_arrival) validationErrors.push('enroll_cabinet_page.personal_info_tab.country_of_arrival');
        if (!enrollCabinet.personal_info.city_of_arrival) validationErrors.push('enroll_cabinet_page.personal_info_tab.city_of_arrival');
      }*/

      /*if (enrollCabinet.personal_info.born_in_other_country) {
        if (!enrollCabinet.personal_info.other_country_birth_place) {
          validationErrors.push('enroll_cabinet_page.personal_info_tab.other_country_birth_place');
        }
      } else if (!enrollCabinet.personal_info.birth_place) {
        validationErrors.push('enroll_cabinet_page.personal_info_tab.birth_place');
      }*/
      validationErrors.push('enroll_cabinet_page.personal_info_tab.personal_info');
    }

    if (enrollCabinet.personal_info.citizenship == 113
      || enrollCabinet.personal_info.citizenship != 113 && enrollCabinet.personal_info.has_iin) {
      const iinIsIncorrect = !_utils.validateIin(enrollCabinet.personal_info.iin, enrollCabinet.personal_info.birth_date, enrollCabinet.personal_info.sex);
      if (iinIsIncorrect && !enrollCabinet.personal_info.iin_gived_gosorgan) {
        validationErrors.push('enroll_cabinet_page.personal_info_tab.incorrect_iin');
      }
    }

    // Документы
    if (!enrollCabinet.documents.id_type ||
      !enrollCabinet.documents.id_number ||
      !enrollCabinet.documents.id_begin_date ||
      !enrollCabinet.documents.select_id_give_organ) {

      if (!enrollCabinet.documents.id_type) { validationErrors.push('enroll_cabinet_page.documents_tab.id_type'); }
      if (!enrollCabinet.documents.id_number) { validationErrors.push('enroll_cabinet_page.documents_tab.id_number'); }
      if (!enrollCabinet.documents.id_begin_date) { validationErrors.push('enroll_cabinet_page.documents_tab.id_begin_date'); }

      if (enrollCabinet.documents.select_id_give_organ === 3) {
        if (!enrollCabinet.documents.id_give_organ) { validationErrors.push('enroll_cabinet_page.documents_tab.id_give_organ'); }
      }
      validationErrors.push('enroll_cabinet_page.tabs.documents');
    }
    if (!dics.nonRequireDocScans && !enrollCabinet.fromEgov) {
      if (!enrollCabinet.documents.id_scan.fileId ||
        !enrollCabinet.documents.scan_086.fileId) {
        validationErrors.push('enroll_cabinet_page.documents_tab.id_scan');
        validationErrors.push('enroll_cabinet_page.documents_tab.086_scan');
      }
    }

    // Контакты
    if (!enrollCabinet.contacts.phone ||
      !enrollCabinet.contacts.mail) {
      validationErrors.push('enroll_cabinet_page.tabs.contacts');
    }

    // Сведения о поступлении
    if (!enrollCabinet.entrance_info.learn_lang ||
      !enrollCabinet.entrance_info.speciality ||
      !enrollCabinet.entrance_info.qualification ||
      !enrollCabinet.collegeId ||
      !enrollCabinet.entrance_info.reg_date ||
      !enrollCabinet.entrance_info.department_id) {

     /* if (!isEnroll) {
        if (!enrollCabinet.entrance_info.payment_form)
          validationErrors.push('enroll_cabinet_page.entrance_info_tab.payment_form');
      }*/

      if (enrollCabinet.entrance_info.hostel === 1 && !enrollCabinet.entrance_info.hostel_need_cause) {
        if (enrollCabinet.entrance_info.hostel) {
          if (enrollCabinet.entrance_info.hostel === 1) {
            if (!enrollCabinet.entrance_info.hostel_need_cause) {
              validationErrors.push('enroll_cabinet_page.entrance_info_tab.hostel_need_cause');
            }
          }
        }
      }
      validationErrors.push('enroll_cabinet_page.tabs.entrance_info');
    }

    // Сведения об образовании
    if (enrollCabinet.edu_info.edu_institute_graduate) {
      if (enrollCabinet.edu_info.edu_institute_graduate === 1) {// закончил школу
        if (enrollCabinet.edu_info.edu_institute_country === 113) { // закончил школу в Казахстане

          if (!enrollCabinet.edu_info.edu_institute_place ||
            !enrollCabinet.edu_info.edu_institute_localty) {
            validationErrors.push('enroll_cabinet_page.edu_info_tab.edu_institute_place');
          }
          if (!enrollCabinet.edu_info.edu_org_name && !enrollCabinet.edu_info.institutionId // если другое выбран
          ) {
            validationErrors.push('enroll_cabinet_page.edu_info_tab.edu_org_name');
          }
          if (!enrollCabinet.edu_info.edu_received) {
            validationErrors.push('enroll_cabinet_page.edu_info_tab.edu_received');
          }
          // проверка аттестата
          if (!enrollCabinet.edu_info.attestat.attestat_series ||
            !enrollCabinet.edu_info.attestat.attestat_number ||
            !enrollCabinet.edu_info.attestat.attestat_give_date ||
            !(enrollCabinet.edu_info.attestat.attestat_average_ball || enrollCabinet.edu_info.finishedCorrectionalSchool)) {
            validationErrors.push('enroll_cabinet_page.edu_info_tab.attestat.title');
          }
          if (!dics.nonRequireDocScans && !enrollCabinet.fromEgov) {
            if (!enrollCabinet.edu_info.attestat.attestat_scan.fileId) {
              validationErrors.push('enroll_cabinet_page.edu_info_tab.attestat.attestat_scan');
            }
          }

        } else if (enrollCabinet.edu_info.edu_institute_country !== 113) { // закончил школу НЕ в Казахстане
          if (!enrollCabinet.edu_info.edu_doc_name ||
            !enrollCabinet.edu_info.edu_doc_give_date
            || (!enrollCabinet.edu_info.edu_org_name ) // если другое выбран
            ) {
            validationErrors.push('enroll_cabinet_page.edu_info_tab.edu_org_name');
          }
          if (!dics.nonRequireDocScans && !enrollCabinet.fromEgov) {
            if (!enrollCabinet.edu_info.edu_doc_scan.fileId) {
              validationErrors.push('enroll_cabinet_page.edu_info_tab.edu_doc_scan');
            }
          }
          // проверка балла аттестата
          if (!(enrollCabinet.edu_info.attestat.attestat_average_ball || enrollCabinet.edu_info.finishedCorrectionalSchool)) {
            validationErrors.push('enroll_cabinet_page.edu_info_tab.attestat.title');
          }
        } else {
          validationErrors.push('enroll_cabinet_page.edu_info_tab.edu_institute_graduate');
        }
      }

      if (enrollCabinet.edu_info.edu_institute_graduate === 2) { // закончил колледж
        if (enrollCabinet.edu_info.edu_institute_country === 113) { // закончил колледж в Казахстане
          if (!enrollCabinet.edu_info.edu_institute_place ||
            !enrollCabinet.edu_info.edu_institute_localty) {
            validationErrors.push('enroll_cabinet_page.edu_info_tab.edu_institute_place');
          }
          if (!enrollCabinet.edu_info.edu_org_name && !enrollCabinet.edu_info.institutionId) {
            validationErrors.push('enroll_cabinet_page.edu_info_tab.edu_org_name');
          }

        } else if (enrollCabinet.edu_info.edu_institute_country !== 113) { // закончил колледж НЕ в Казахстане
          if (!enrollCabinet.edu_info.edu_doc_name
            || (!enrollCabinet.edu_info.edu_org_name) ) {
            validationErrors.push('enroll_cabinet_page.edu_info_tab.edu_org_name');
          }
        } else {
          validationErrors.push('enroll_cabinet_page.edu_info_tab.edu_institute_graduate');
        }
      }

      if (enrollCabinet.edu_info.edu_institute_graduate === 3) { // закончил ВУЗ
        if (!enrollCabinet.edu_info.edu_graduate_domestic) {
          validationErrors.push('enroll_cabinet_page.edu_info_tab.edu_institute_graduate');
        }
        if (enrollCabinet.edu_info.edu_graduate_domestic === 1) { // закончил отечественный ВУЗ
          if (!enrollCabinet.edu_info.edu_graduate_domestic_operating_univ) {
            validationErrors.push('enroll_cabinet_page.edu_info_tab.edu_institute_graduate');
          }
          if (enrollCabinet.edu_info.edu_graduate_domestic_operating_univ) {
            if (!enrollCabinet.edu_info.edu_graduate_domestic_univ_name ||
              !enrollCabinet.edu_info.edu_graduate_domestic_univ_spec ||
              !enrollCabinet.edu_info.edu_graduate_domestic_univ_gpa) {
              validationErrors.push('enroll_cabinet_page.edu_info_tab.edu_institute_graduate');
            }
          }
        }
        if (enrollCabinet.edu_info.edu_graduate_domestic === 0) { // закончил зарубежный ВУЗ
          if (!enrollCabinet.edu_info.edu_graduate_foreign_name ||
            !enrollCabinet.edu_info.edu_graduate_foreign_spec) {
            validationErrors.push('data.edu_info.edu_graduate_foreign_name');
            validationErrors.push('data.edu_info.edu_graduate_foreign_spec');
          }
        }
      }


      if (isTechSecretary) {
        // Тип поступления
        if (!enrollCabinet.edu_info.type_of_admission) {
          validationErrors.push('enroll_cabinet_page.edu_info_tab.type_of_admission.title');
        }

        // Данные о поступлении
        if (enrollCabinet.edu_info.type_of_admission === 0) {

        }
        // Данные по результатам ЕНТ/КТ
        if (enrollCabinet.edu_info.type_of_admission === 1) { // выбрано КТ/ЕНТ
          /*if (!enrollCabinet.edu_info.ent_kt_serificate_info.ent_kt_serificate_give_date ||
            !enrollCabinet.edu_info.ent_kt_serificate_info.ent_kt_serificate_series ||
            !enrollCabinet.edu_info.ent_kt_serificate_info.individual_code_test ||
            !enrollCabinet.edu_info.ent_kt_serificate_info.ent_kt_serificate_number ||
            !enrollCabinet.edu_info.ent_kt_serificate_info.exam_lang) {
             validationErrors.push('enroll_cabinet_page.edu_info_tab.ent_kt_serificate_info.title');
          }*/
          /*if (!dics.nonRequireDocScans && !enrollCabinet.fromEgov) {
            if (!enrollCabinet.edu_info.ent_kt_serificate_info.ent_kt_serificate_scan.fileId) {
              validationErrors.push('enroll_cabinet_page.edu_info_tab.ent_kt_serificate_info.ent_kt_serificate_scan');
            }
          }*/
        }
        // // Данные по собеседованию
        // if (enrollCabinet.edu_info.type_of_admission === 2) { // выбрано Собеседование
        //   if (!enrollCabinet.edu_info.interview_info.protocol_number) {
        //     validationErrors.push('enroll_cabinet_page.edu_info_tab.interview_info.protocol_number');
        //   }
        // }
      }

      // Данные по диплому
      if (enrollCabinet.edu_info.edu_institute_graduate !== 1) {
        if (enrollCabinet.edu_info.edu_institute_graduate === 2) {
        }
        if (enrollCabinet.edu_info.edu_institute_graduate === 3) {
        }
        if (!enrollCabinet.edu_info.diplom_info.diplom_series ||
          !enrollCabinet.edu_info.diplom_info.diplom_number ||
          !enrollCabinet.edu_info.diplom_info.otherSpeciality ||
          !enrollCabinet.edu_info.diplom_info.diplom_give_date ||
          !enrollCabinet.edu_info.attestat.attestat_average_ball) {
          validationErrors.push('enroll_cabinet_page.edu_info_tab.diplom_info.title');
        }
        if (!dics.nonRequireDocScans && !enrollCabinet.fromEgov) {
          if (!enrollCabinet.edu_info.diplom_info.diplom_scan.fileId) {
            validationErrors.push('enroll_cabinet_page.edu_info_tab.diplom_info.diplom_scan');
          }
          if (!enrollCabinet.edu_info.diplom_info.diplom_app_scan.fileId) {
            validationErrors.push('enroll_cabinet_page.edu_info_tab.diplom_info.diplom_app_scan');
          }
          /*if (!enrollCabinet.edu_info.diplom_info.essay.fileId) {
            validationErrors.push('enroll_cabinet_page.edu_info_tab.diplom_info.essay');
          }*/
        }

        if (enrollCabinet.edu_info.edu_graduate_domestic === 1 && enrollCabinet.edu_info.edu_institute_graduate === 3) {
          if (!enrollCabinet.edu_info.edu_graduate_domestic_operating_univ) {
            validationErrors.push('enroll_cabinet_page.edu_info_tab.edu_graduate.vuz_types.domestic.operating_univ_title');
          }
        }
        if (enrollCabinet.edu_info.edu_graduate_domestic_operating_univ === 1) {
          if (!enrollCabinet.edu_info.edu_graduate_domestic_univ_name || !enrollCabinet.edu_info.edu_graduate_domestic_univ_spec) {
            validationErrors.push('enroll_cabinet_page.edu_info_tab.edu_graduate.vuz_types.domestic.operating_univ.name');
            validationErrors.push('enroll_cabinet_page.edu_info_tab.edu_graduate.vuz_types.domestic.operating_univ.spec');
          }
        }
      }
    } else {
      validationErrors.push('enroll_cabinet_page.edu_info_tab.edu_institute_graduate');
    }

    // Сведения о договоре и оплате за обучение
    // if (!isEnroll && isTechSecretary) {
    //   if (!enrollCabinet.contract_payments_info.contract_edu_service_date ||
    //     !enrollCabinet.contract_payments_info.contract_edu_service_number ||
    //     !enrollCabinet.contract_payments_info.contract_edu_service_reg_number ||
    //     !enrollCabinet.contract_payments_info.payment_amount ||
    //     !enrollCabinet.contract_payments_info.payment_bank_name ||
    //     !enrollCabinet.contract_payments_info.payment_date ||
    //     !enrollCabinet.contract_payments_info.ticket_receipt_number) {
    //     validationErrors.push('enroll_cabinet_page.tabs.contract_payments_info');
    //   }
    // }
    return validationErrors.length === 0;
  }

  // метод нормализации формы для отправки, как как типы полей могут несовпасть
  normalizeFrom(enrollCabinet: EnrollCabinet) {
    return new Promise((resolve) => {
      if (!enrollCabinet.edu_info.edu_institute_localty) {
        enrollCabinet.edu_info.edu_institute_localty = null;
      }
      if (!enrollCabinet.edu_info.edu_graduate_domestic_univ_gpa || enrollCabinet.edu_info.edu_graduate_domestic_univ_gpa === 'null') {
        enrollCabinet.edu_info.edu_graduate_domestic_univ_gpa = null;
      }
      resolve();
    });
  }

  validateEnrollAlternativeColleges(alternativeColleges: AlternativeCollegeItem[], validationErrors: any[], setAlternativeColleges: boolean, enrollCabinet: EnrollCabinet, isTechSecretary: boolean) {
    if (setAlternativeColleges) {
      alternativeColleges.forEach(value => {
        if (!value.sourceCollege) {
          if (value.specId > 0 && (!value.collegeId || !value.qualificationId) && validationErrors.length == 0) {
            validationErrors.push('enroll_cabinet_page.entrance_info_tab.alternative_colleges_for_entrance.error_on_fill_block');
          }
          value.entrance_exams_info.mandatory_subjects.forEach(ms => {
            if (value.specId > 0 && !(ms.subjectId  || (enrollCabinet.edu_info.edu_institute_country != 113 && !isTechSecretary)
            || enrollCabinet.edu_info.finishedCorrectionalSchool
              || (!isTechSecretary && enrollCabinet.edu_info.edu_institute_graduate == 2)
              || enrollCabinet.edu_info.type_of_admission == 2) && validationErrors.indexOf('enroll_cabinet_page.edu_info_tab.entrance_exams_info.mandatory_subjects') == -1) {
              validationErrors.push('enroll_cabinet_page.edu_info_tab.entrance_exams_info.mandatory_subjects');
            }
          });
          value.entrance_exams_info.profile_subjects.forEach(ps => {
            if (value.specId > 0 && !(ps.subjectId  || (enrollCabinet.edu_info.edu_institute_country != 113 && !isTechSecretary)
            || enrollCabinet.edu_info.finishedCorrectionalSchool
              || (!isTechSecretary && enrollCabinet.edu_info.edu_institute_graduate == 2)
              || enrollCabinet.edu_info.type_of_admission == 2) && validationErrors.indexOf('enroll_cabinet_page.edu_info_tab.entrance_exams_info.profile_subjects') == -1) {
              validationErrors.push('enroll_cabinet_page.edu_info_tab.entrance_exams_info.profile_subjects');
            }
          });
        }
      });
      return validationErrors.length === 0;
    }
    return true;
  }

  validateMainForm(enrollCabinet: EnrollCabinet, validationErrors: any[], isTechSecretary: boolean, userCollegeId): boolean  {
    if (isTechSecretary) {
      if (enrollCabinet.collegeId > 0) {
        if (enrollCabinet.collegeId != userCollegeId) {
          validationErrors.push('priority_college_incorrect_college');
        }
      } else {
        enrollCabinet.userCollegeId = userCollegeId;
      }
    }
    return validationErrors.length === 0;
  }

  validateInRanging(ec: EnrollCabinet, validationErrors: any[],
                    mainCollegeNamesDic: any[], mainCollegeProfessionsDic: any[], mainCollegeQualificationsDic: any[],
                    setAlternativeColleges: boolean, alternativeCollegesDictionary: any[], alternativeCollegesProfessions: any[], alternativeCollegesQualificationArrays: any[]) {
    if (ec.entrance_info.inRanging === ParticipateInRanging.YES) {

      if (ec.entrance_info.specialExamProvided) {
        if (ec.entrance_info.specialExamType === SpecialExamType.PASS_FAIL) {
          if (ec.entrance_info.specialExam !== 1 && validationErrors.indexOf('enroll_cabinet_page.entrance_info_tab.inRangingErrors.setPassForSpecialExam') == -1) {
            validationErrors.push('enroll_cabinet_page.entrance_info_tab.inRangingErrors.setPassForSpecialExam');
          }
        } else if (ec.entrance_info.specialExamType === SpecialExamType.MARK) {
          if (ec.entrance_info.specialExam < 3 && validationErrors.indexOf('enroll_cabinet_page.entrance_info_tab.inRangingErrors.setCorrectMarkForSpecialExam') == -1) {
            validationErrors.push('enroll_cabinet_page.entrance_info_tab.inRangingErrors.setCorrectMarkForSpecialExam');
          }
        } else {
          if (validationErrors.indexOf('enroll_cabinet_page.entrance_info_tab.inRangingErrors.specialExamTypeNotSet') == -1) {
            validationErrors.push('enroll_cabinet_page.entrance_info_tab.inRangingErrors.specialExamTypeNotSet');
          }
        }
      }

    }


    const FoundDifferentMark = {e: 'different', additional: ''};
    const FoundUnsatisfactoryMark = {e: 'unsatisfactory', additional: ''};
    const NoGrantForSpecialization = {e: 'noGrant', additional: ''};
    const NoPlaceInCollege = {e: 'noPlace', additional: ''};
    const map = new Map<number, number>();
    try {
      if (ec.entrance_info.inRanging === ParticipateInRanging.YES) {
        this.fillMap(map, ec.edu_info.entrance_exams_info.mandatory_subjects, FoundUnsatisfactoryMark, ec.edu_info.finishedCorrectionalSchool);
        this.fillMap(map, ec.edu_info.entrance_exams_info.profile_subjects, FoundUnsatisfactoryMark, ec.edu_info.finishedCorrectionalSchool);


        const professionExists = mainCollegeProfessionsDic.some(v => v.id === ec.entrance_info.speciality);
        const qualificationExists = mainCollegeQualificationsDic.some(v => v.id === ec.entrance_info.qualification);
        const collegeExists = mainCollegeNamesDic.some(v => v.id === ec.collegeId);
        if (!professionExists) {
          throw NoGrantForSpecialization;
        }
        if (!qualificationExists) {
          throw NoGrantForSpecialization;
        }
        if (!collegeExists) {
          // NoPlaceInCollege.additional = 'text';
          throw NoPlaceInCollege;
        }
      }
      if (setAlternativeColleges) {
        ec.alternativeColleges.forEach((c: AlternativeCollegeItem) => {
          if (c.sourceCollege) {
            return;
          }
          if (c.inRanging === ParticipateInRanging.YES) {
            if (!ec.edu_info.finishedCorrectionalSchool) {
              this.checkDifference(c.entrance_exams_info.mandatory_subjects, map, FoundDifferentMark, FoundUnsatisfactoryMark, ec.edu_info.finishedCorrectionalSchool);
              this.checkDifference(c.entrance_exams_info.profile_subjects, map, FoundDifferentMark, FoundUnsatisfactoryMark, ec.edu_info.finishedCorrectionalSchool);
            }
            const professionExists = alternativeCollegesProfessions.some(v => v.id === c.specId);
            const qualificationExists = alternativeCollegesQualificationArrays[c.number].some(v => v.id === c.qualificationId);
            const collegeExists = alternativeCollegesDictionary[c.number].some(v => v.id === c.collegeId);
            if (!professionExists) {
              throw NoGrantForSpecialization;
            }
            if (!qualificationExists) {
              throw NoGrantForSpecialization;
            }
            if (!collegeExists) {
              throw NoPlaceInCollege;
            }
          }
        });
      }
    } catch (e) {
      if (e === FoundDifferentMark) {
        validationErrors.push('enroll_cabinet_page.entrance_info_tab.inRangingErrors.differentMarks');
      } else if (e === FoundUnsatisfactoryMark) {
        validationErrors.push('enroll_cabinet_page.entrance_info_tab.inRangingErrors.setCorrectMarks');
      } else if (e === NoGrantForSpecialization) {
        validationErrors.push('enroll_cabinet_page.entrance_info_tab.inRangingErrors.grantsDeleted');
      } else if (e === NoPlaceInCollege) {
        validationErrors.push('enroll_cabinet_page.entrance_info_tab.inRangingErrors.capacityNotSet');
        validationErrors.push(e.additional);
      } else {
        throw e;
      }
    }
    if (validationErrors.length > 0) {
      validationErrors.unshift('enroll_cabinet_page.entrance_info_tab.inRangingErrors.foundErrors');
    }
    return validationErrors.length === 0;
  }

  private fillMap(map: Map<number, number>, subjects: ExamsSubjectsBalls[], FoundUnsatisfactoryMark: {}, correctionalSchool: boolean) {
    subjects.forEach(s => {
      if (s.points < 3 && !correctionalSchool) {
        throw FoundUnsatisfactoryMark;
      }
      map.set(s.subjectId, s.points);
    });
  }

  private checkDifference(subjects: ExamsSubjectsBalls[], map: Map<number, number>, FoundDifferentMark: {}, FoundUnsatisfactoryMark: {}, correctionalSchool: boolean) {
    subjects.forEach(s => {
      if (map.has(s.subjectId)) {
        if (map.get(s.subjectId) !== s.points && !correctionalSchool) {
          throw FoundDifferentMark;
        }
      } else {
        this.fillMap(map, [s], FoundUnsatisfactoryMark, correctionalSchool);
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/enroll-cabinet/enroll-cabinet-validation.ts